import { render, staticRenderFns } from "./CustomConfirmClearData.vue?vue&type=template&id=8891d648&"
import script from "./CustomConfirmClearData.vue?vue&type=script&lang=js&"
export * from "./CustomConfirmClearData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports